import React from "react";

import {
  ArrowIcon,
  CardButton,
  CardFill,
  CardItem,
  CardList,
  CardText,
  Container,
  CrossIcon,
  DefaultText,
  HoverText,
} from "./styles";

type TCircleCardsSection = {
  cards: string[];
  activeCardIndex: number;
  ariaLabel: string;
  stackDirection?: "leftOnTop" | "rightOnTop";
  hoverText?: string;
};

export const CircleCardsSection: React.FC<TCircleCardsSection> = ({
  cards,
  activeCardIndex,
  ariaLabel,
  stackDirection = "leftOnTop",
  hoverText = "записаться на встречу-знакомство",
}) => (
  <Container>
    <CardList aria-label={ariaLabel}>
      {cards.map((text, index) => {
        const isActiveCard = index === activeCardIndex;
        const hasArrow = index < cards.length - 1;
        const hasNextCard = index < cards.length - 1;
        const zIndex = stackDirection === "leftOnTop"
          ? cards.length - index
          : index + 1;

        return (
          <CardItem
            key={text}
            $isActiveCard={isActiveCard}
            $hasNextCard={hasNextCard}
            $zIndex={zIndex}
          >
            {isActiveCard && (
              <CardButton
                href="https://t.me/ProhorovaConsult"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Записаться на встречу-знакомство"
              >
                <CrossIcon aria-hidden="true" />
              </CardButton>
            )}
            {isActiveCard && <CardFill aria-hidden="true" />}
            <CardText>
              <DefaultText>{text}</DefaultText>
              {isActiveCard && <HoverText>{hoverText}</HoverText>}
            </CardText>
            {hasArrow && <ArrowIcon aria-hidden="true" />}
          </CardItem>
        );
      })}
    </CardList>
  </Container>
);
